export class TextSettings {
  constructor(overrides = {}) {    
    const defaults = {
      color: '#000000',
      align: 'left',
      font: { fontSize: 14, fontWeight: '400', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },
      padding: { paddingLeft: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 10 },
      margin: { marginLeft: 10, marginRight: 10, marginTop: 10, marginBottom: 10 },
      text: 'Text',
      choice_options: [],
      width: { type: 'auto', value: 100 },
      link: { fontWeight: '400', color: '#0000ff', textDecoration: 'none' },
      hover: { fontWeight: '400', color: '#0000ff', textDecoration: 'underline' },
    };
    Object.assign(this, defaults, overrides);
  }
}

export const TextTypes = {
  content: {
    text: { title: 'Text', type: 'Text' },
  },
  orientation: {
    align: { title: 'Text Align', type: 'Align' },
    width: { title: 'Width', type: 'Size' },
    padding: { title: 'Inner Spacing', type: 'Padding' },
    margin: { title: 'Margin', type: 'Margin' },
  },
  styles: {
    font: { title: 'Font', type: 'Font' },
  },
  links: {
    link: { title: 'Link Style', type: 'Links' },
    hover: { title: 'Hover Style', type: 'Links' },
  }
};